import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:token',
    name: 'MatchedAd',
    component: () => import(/* webpackChunkName: "matched-ad" */ '../views/MatchedAd.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
